import { SingleOperation } from "../operations/Operation";
import { Verb } from "../types/Verb";
import Camera from "../Camera";
import { SimpleShape2 } from "./StandardShapes";
import { makeAttributeList } from "../ShapeStore";
import { getStandardShapeScreenToBoundedDelta } from "@/wbcontroller/standardShapes/standardShapeConversions";
import { getStandardPadding } from "../util";

export default class AddStandardShapeOperation extends SingleOperation {
  shapePrototype: SimpleShape2;

  constructor(
    newShapeID: string,
    camera: Camera,
    shapePrototype: SimpleShape2,
    keepAtZoomLevel1 = false
  ) {
    const delta = getStandardShapeScreenToBoundedDelta(
      camera,
      shapePrototype,
      getStandardPadding(shapePrototype),
      keepAtZoomLevel1
    );
    console.log(shapePrototype, delta);
    const newShape = {
      ...shapePrototype,
      ...delta,
    };

    super(
      [
        {
          verb: Verb.UpsertSubjectAttributeMany,
          subjectID: newShapeID,
          version: -1,
          attributes: makeAttributeList({ ...shapePrototype, ...newShape }),
        },
      ],
      [
        {
          verb: Verb.DeleteShape,
          subjectID: newShapeID,
        },
      ]
    );
    this.shapePrototype = shapePrototype;
  }

  get label(): string {
    return `Add ${this.shapePrototype.shapeType}`;
  }
}
